<template>
    <div class="col-lg-8 col-xlg-9 col-md-7">
        <div class="card">
            <div class="card-header">
                <div class="d-md-flex align-items-center">
                    <div>
                        <h4 class="card-title"><i class="mdi mdi-account-multiple"></i> Staff in your organization</h4>
                        <h5 class="card-subtitle">Your team members who have access to AcreCX platform</h5>
                    </div>
                </div>
            </div>
            <div class="table-responsive">
                <table class="table v-middle">
                    <thead>
                    <tr class="bg-light">
                        <th class="border-top-0">Name</th>
                        <th class="border-top-0">Email</th>
                        <th class="border-top-0">Role</th>
                        <th class="border-top-0">Status</th>
                        <th class="border-top-0 text-center">Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(member, index) in members" v-bind:key="index">
                        <td>
                            <div class="d-flex align-items-center">
                                <div class="m-r-10">
                                    <blockie :address="member.email"></blockie>
                                </div>
                                <div class="">
                                    <h4 class="m-b-0 font-16">{{member.first_name}} {{member.last_name}}</h4>
                                </div>
                            </div>
                        </td>
                        <td>{{member.email}}</td>
                        <td>{{member.org_role}}</td>
                        <td>
                            <label class="label label-success">Active</label>
                        </td>
                        <td class="text-center">
                            <a href="javascrit:void(0)"
                               data-target="#whAccessModal"
                               data-toggle="modal"
                               title="Edit Access"
                               @click="setWarehouse(member.id, member.warehouses)"
                               v-if="member.org_role === 'INVENTORY_MANAGER'">
                                <i class="fa fa-user-lock"/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="modal fade" id="whAccessModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Select Warehouse</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row mt-5 mb-5">
                            <div class="col-lg-2 col-xs-12 text-right pt-1">
                                <label class="col-form-label">Warehouses</label>
                            </div>

                            <div class="col-lg-10 col-xs-12">
                                <multiselect v-model="warehouses"
                                             class="form-control"
                                             tag-placeholder="Add this as new tag"
                                             placeholder="Search or add a tag"
                                             label="name"
                                             id="warehouses"
                                             track-by="id"
                                             :options="options"
                                             :multiple="true"
                                             :taggable="true"
                                             @tag="addTag">
                                </multiselect>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" @click="updateAccess">Save changes</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../common/Blockie";
    import Multiselect from "vue-multiselect"

    export default {
        name: "Members",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Multiselect},
        data() {
            return {
                members: [],
                warehouses: [],
                options: [],
                org_user_id: null
            };
        },
        mounted() {
            $('#whAccessModal').on('hidden.bs.modal', (e) => {
                this.warehouses  = [];
                this.org_user_id = null;
            })
            this.getMembers();
            this.getAllWarehouse();
        },
        methods: {
            getMembers() {
                $(".preloader").fadeIn();
                this.$http
                .get("/org/" + this.currentOrg.id + "/members")
                .then(reply => {
                    $(".preloader").fadeOut();
                    this.members = reply.data;
                })
                .catch(err => {
                    $(".preloader").fadeOut();
                    console.log(err);
                });
            },
            addTag(newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                }
                this.options.push(tag)
                this.warehouses.push(tag)
            },
            async getAllWarehouse() {
                let {data}   = await this.$http.get(`express/${this.currentOrg.express_id}/inventory/warehouses`);
                let reply    = await this.$http.get(`express/${this.currentOrg.express_id}/inventory/warehouses`,
                {
                    params: {
                        page: 1,
                        perPage: data.total
                    }
                })
                this.options = reply.data.warehouses;
            },
            setWarehouse(orgUserId, warehouseIds) {
                this.org_user_id = orgUserId;
                warehouseIds.forEach(id => {
                    let items = _.filter(this.options, {id: id});
                    if(items.length > 0) {
                        this.warehouses.push({id: items[0].id, name: items[0].name});
                    }
                });
            },
            async updateAccess() {
                let payload = {
                    org_user_id: this.org_user_id,
                    warehouses: []
                };

                this.warehouses.forEach(wh => {
                    payload.warehouses.push(wh.id);
                });

                try {
                    await this.$http.post(`express/${this.currentOrg.express_id}/inventory/access`, payload);
                    this.$toastr('success', "Accesss updated", "Success");
                    await this.getMembers();
                } catch(e) {
                    this.$toastr('error', "Update access failed", "Failed");
                } finally {
                    $('#whAccessModal').modal('hide');
                }
            }
        }
    }
</script>

<style scoped>

</style>
